package com.ijoin.data.repository

import com.ijoin.data.api.EventApi
import com.ijoin.data.model.Event
import com.ijoin.data.model.EventWizardRequest
import kotlinx.datetime.Instant

class EventRepository(
    private val eventApi: EventApi = EventApi()
) {
    suspend fun getUpcomingEvents(page: Int = 0, size: Int = 20): Result<List<Event>> {
        return eventApi.getUpcomingEvents(page, size)
    }

    suspend fun searchEvents(query: String, page: Int = 0, size: Int = 20): Result<List<Event>> {
        return eventApi.searchEvents(query, page, size)
    }

    suspend fun getEventById(eventId: String): Result<Event> {
        return eventApi.getEventById(eventId)
    }

    suspend fun getOccurrenceCapacity(eventId: String, occurrenceDateTime: Instant) =
        eventApi.getOccurrenceCapacity(eventId, occurrenceDateTime)

    suspend fun getOccurrencesCapacity(eventId: String, occurrences: List<Instant>) =
        eventApi.getOccurrencesCapacity(eventId, occurrences)

    suspend fun getFavoriteEvents(): Result<List<Event>> {
        return eventApi.getFavoriteEvents()
    }

    suspend fun toggleFavorite(eventId: String, isFavorite: Boolean): Result<Unit> {
        return if (isFavorite) {
            eventApi.removeFromFavorites(eventId)
        } else {
            eventApi.addToFavorites(eventId)
        }
    }

    suspend fun isFavorite(eventId: String): Result<Boolean> {
        return eventApi.isFavorite(eventId)
    }

    suspend fun createEventFromWizard(payload: EventWizardRequest) =
        eventApi.createEventFromWizard(payload)

    suspend fun updateEventFromWizard(eventId: String, payload: EventWizardRequest) =
        eventApi.updateEventFromWizard(eventId, payload)

    suspend fun cancelEvent(eventId: String, reason: String?): Result<Event> =
        eventApi.cancelEvent(eventId, reason)

    suspend fun restoreEvent(eventId: String): Result<Event> =
        eventApi.restoreEvent(eventId)

    suspend fun deleteEvent(eventId: String): Result<Unit> =
        eventApi.deleteEvent(eventId)
}
